webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _bootstrapVue = __webpack_require__(182);
	
	var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);
	
	var _vueResource = __webpack_require__(234);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vuex = __webpack_require__(167);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vueCarousel = __webpack_require__(228);
	
	var _vueCarousel2 = _interopRequireDefault(_vueCarousel);
	
	var _jquery = __webpack_require__(222);
	
	var $$ = _interopRequireWildcard(_jquery);
	
	__webpack_require__(217);
	
	__webpack_require__(216);
	
	__webpack_require__(218);
	
	var _vueAwesome = __webpack_require__(172);
	
	var Icon = _interopRequireWildcard(_vueAwesome);
	
	var _router = __webpack_require__(170);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(229);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(31);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_bootstrapVue2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vueCarousel2.default);
	_vue2.default.use($$);
	
	window.$ = $$;
	window.jQuery = $$;
	
	_vue2.default.component('icon', Icon);
	
	window.bus = new _vue2.default();
	
	_vue2.default.http.options.credentials = false;
	
	new _vue2.default({
	  el: '#app',
	  store: _store2.default,
	  router: _router2.default,
	  template: '<app/>',
	
	  components: {
	    app: _App2.default
	  }
	});

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.USERS_RISING = exports.USERS_NEW = exports.USERS_POPULAR = exports.DATASETS_RISING = exports.DATASETS_NEW = exports.DATASETS_POPULAR = exports.RECENT_DATA_PARTNERS = exports.TAG_CLOUD = exports.RECENT_INTEGRATIONS = exports.FEATURED_DATASETS = exports.API_URL = undefined;
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(167);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _logger = __webpack_require__(169);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	if (!window.origin) {
	  window.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	}
	
	window.getAPIURL = function () {
	  if (debug) {
	    return 'http://explore-data-world.test/';
	  } else {
	    if (checkProd()) {
	      return 'https://api.explore.data.world/';
	    } else {
	      return 'http://api.explore-data-world.treetop.us/';
	    }
	  }
	};
	
	window.getStaticAssetURL = function () {
	  if (debug) {
	    return 'http://equote30.test/';
	  } else {
	    if (checkProd()) {
	      return 'https://api.explore.data.world/';
	    } else {
	      return 'http://api.explore-data-world.treetop.us/';
	    }
	  }
	};
	
	function checkProd() {
	  return window.origin === 'http://explore.data.world' || window.origin === 'https://explore.data.world';
	}
	
	var API_BASE = 'api/';
	
	var API_URL = exports.API_URL = window.getAPIURL();
	
	var FEATURED_DATASETS = exports.FEATURED_DATASETS = API_URL + API_BASE + 'featured-datasets';
	var RECENT_INTEGRATIONS = exports.RECENT_INTEGRATIONS = API_URL + API_BASE + 'recent-integrations';
	var TAG_CLOUD = exports.TAG_CLOUD = API_URL + API_BASE + 'tag-cloud';
	var RECENT_DATA_PARTNERS = exports.RECENT_DATA_PARTNERS = API_URL + API_BASE + 'recent-data-partners';
	var DATASETS_POPULAR = exports.DATASETS_POPULAR = API_URL + API_BASE + 'datasets-popular';
	var DATASETS_NEW = exports.DATASETS_NEW = API_URL + API_BASE + 'datasets-new';
	var DATASETS_RISING = exports.DATASETS_RISING = API_URL + API_BASE + 'datasets-rising';
	var USERS_POPULAR = exports.USERS_POPULAR = API_URL + API_BASE + 'users-popular';
	var USERS_NEW = exports.USERS_NEW = API_URL + API_BASE + 'users-new';
	var USERS_RISING = exports.USERS_RISING = API_URL + API_BASE + 'users-rising';
	
	exports.default = new _vuex2.default.Store({
	  modules: {},
	  strict: debug,
	  plugins: debug ? [(0, _logger2.default)()] : []
	});

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(219)
	
	var Component = __webpack_require__(29)(
	  /* script */
	  __webpack_require__(175),
	  /* template */
	  __webpack_require__(231),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createLogger;
	
	var _util = __webpack_require__(171);
	
	function createLogger() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$collapsed = _ref.collapsed,
	      collapsed = _ref$collapsed === undefined ? true : _ref$collapsed,
	      _ref$filter = _ref.filter,
	      filter = _ref$filter === undefined ? function (mutation, stateBefore, stateAfter) {
	    return true;
	  } : _ref$filter,
	      _ref$transformer = _ref.transformer,
	      transformer = _ref$transformer === undefined ? function (state) {
	    return state;
	  } : _ref$transformer,
	      _ref$mutationTransfor = _ref.mutationTransformer,
	      mutationTransformer = _ref$mutationTransfor === undefined ? function (mut) {
	    return mut;
	  } : _ref$mutationTransfor;
	
	  return function (store) {
	    var prevState = (0, _util.deepCopy)(store.state);
	
	    store.subscribe(function (mutation, state) {
	      if (typeof console === 'undefined') {
	        return;
	      }
	      var nextState = (0, _util.deepCopy)(state);
	
	      if (filter(mutation, prevState, nextState)) {
	        var time = new Date();
	        var formattedTime = ' @ ' + pad(time.getHours(), 2) + ':' + pad(time.getMinutes(), 2) + ':' + pad(time.getSeconds(), 2) + '.' + pad(time.getMilliseconds(), 3);
	        var formattedMutation = mutationTransformer(mutation);
	        var message = 'mutation ' + mutation.type + formattedTime;
	        var startMessage = collapsed ? console.groupCollapsed : console.group;
	
	        try {
	          startMessage.call(console, message);
	        } catch (e) {
	          if (window.__webpack_hot_middleware_reporter__) console.log(message);
	        }
	
	        if (window.__webpack_hot_middleware_reporter__) console.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
	        if (window.__webpack_hot_middleware_reporter__) console.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
	        if (window.__webpack_hot_middleware_reporter__) console.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
	
	        try {
	          console.groupEnd();
	        } catch (e) {
	          if (window.__webpack_hot_middleware_reporter__) console.log('—— log end ——');
	        }
	      }
	
	      prevState = nextState;
	    });
	  };
	}
	
	function repeat(str, times) {
	  return new Array(times + 1).join(str);
	}
	
	function pad(num, maxLength) {
	  return repeat('0', maxLength - num.toString().length) + num;
	}

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(235);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _dwhome = __webpack_require__(166);
	
	var _dwhome2 = _interopRequireDefault(_dwhome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	  routes: [{
	    path: 'dwhome',
	    name: 'dwhome',
	    component: _dwhome2.default
	  }, {
	    path: '/',
	    name: 'home',
	    component: _dwhome2.default
	  }]
	});

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(178);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(32);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.deepCopy = deepCopy;
	exports.forEachValue = forEachValue;
	exports.isObject = isObject;
	exports.isPromise = isPromise;
	exports.assert = assert;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function find(list, f) {
	  return list.filter(f)[0];
	}
	
	function deepCopy(obj) {
	  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
	    return obj;
	  }
	
	  var hit = find(cache, function (c) {
	    return c.original === obj;
	  });
	  if (hit) {
	    return hit.copy;
	  }
	
	  var copy = Array.isArray(obj) ? [] : {};
	
	  cache.push({
	    original: obj,
	    copy: copy
	  });
	
	  (0, _keys2.default)(obj).forEach(function (key) {
	    copy[key] = deepCopy(obj[key], cache);
	  });
	
	  return copy;
	}
	
	function forEachValue(obj, fn) {
	  (0, _keys2.default)(obj).forEach(function (key) {
	    return fn(obj[key], key);
	  });
	}
	
	function isObject(obj) {
	  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object';
	}
	
	function isPromise(val) {
	  return val && typeof val.then === 'function';
	}
	
	function assert(condition, msg) {
	  if (!condition) throw new Error('[vuex] ' + msg);
	}

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var WEIGHTS_LENGTH = 10;
	
	exports.default = {
	  props: {
	    data: {
	      type: Array
	    }
	  },
	  watch: {},
	  data: function data() {
	    return {
	      word_array: this.data,
	      cloud_namespace: Math.floor(Math.random() * 1000000).toString(36),
	      options: {
	        width: "650",
	        height: "500",
	        center: {
	          x: 650 / 2.0,
	          y: 400 / 2.0
	        },
	        shape: false,
	        removeOverflowing: false,
	        weights: 0
	      },
	      already_placed_words: []
	    };
	  },
	  mounted: function mounted() {
	    this.word_array.forEach(function (elem, index) {
	      this.drawOneWord(index, elem);
	    }.bind(this));
	  },
	
	  methods: {
	    hitTest: function hitTest(elem, other_elems) {
	      var overlapping = function overlapping(a, b) {
	        if (Math.abs(2.0 * a.offsetLeft + a.offsetWidth - 2.0 * b.offsetLeft - b.offsetWidth) < a.offsetWidth + b.offsetWidth) {
	          if (Math.abs(2.0 * a.offsetTop + a.offsetHeight - 2.0 * b.offsetTop - b.offsetHeight) < a.offsetHeight + b.offsetHeight) {
	            return true;
	          }
	        }
	        return false;
	      };
	      var i = 0;
	
	      for (i = 0; i < other_elems.length; i++) {
	        if (overlapping(elem, other_elems[i])) {
	          return true;
	        }
	      }
	      return false;
	    },
	    drawOneWord: function drawOneWord(index, word) {
	      var word_id = this.cloud_namespace + "_word_" + index,
	          word_selector = "#" + word_id,
	          angle = 6.28 * Math.random(),
	          radius = 0.0,
	          steps_in_direction = 0.0,
	          quarter_turns = 0.0,
	          weight = 5,
	          custom_class = "",
	          inner_html = "",
	          word_span,
	          word_link,
	          href;
	
	      if (this.word_array[0].weight > this.word_array[this.word_array.length - 1].weight) {
	        weight = Math.round((word.weight - this.word_array[this.word_array.length - 1].weight) / (this.word_array[0].weight - this.word_array[this.word_array.length - 1].weight) * (WEIGHTS_LENGTH - 1)) + 1;
	      }
	
	      word_span = document.createElement("a");
	      word_span.href = word.link;
	      word_span.target = '_blank';
	      word_span.className = "w" + weight;
	      var textNode = document.createTextNode(word.text);
	
	      word_span.appendChild(textNode);
	
	
	      document.getElementById("vue-tag-cloud").appendChild(word_span);
	
	      if (this.options.weights) {
	        word_span.style.fontSize = this.options.weights[weight - 1];
	      }
	
	      var width = word_span.offsetWidth,
	          height = word_span.offsetHeight,
	          left = this.options.center.x - width / 2.0,
	          top = this.options.center.y - height / 2.0;
	
	      var word_style = word_span.style;
	      word_style.position = "absolute";
	      word_style.left = left + "px";
	      word_style.top = top + "px";
	
	      var step = this.options.shape === "rectangular" ? 18.0 : 2.0,
	          aspect_ratio = this.options.width / this.options.height;
	
	      while (this.hitTest(word_span, this.already_placed_words)) {
	        radius += step;
	        angle += (index % 2 === 0 ? 1 : -1) * step;
	
	        left = this.options.center.x - width / 2.0 + radius * Math.cos(angle) * aspect_ratio;
	        top = this.options.center.y + radius * Math.sin(angle) - height / 2.0;
	
	        word_style.left = left + "px";
	        word_style.top = top + "px";
	      }
	
	      if (this.options.removeOverflowing && (left < 0 || top < 0 || left + width > options.width || top + height > options.height)) {
	        word_span.remove();
	        return;
	      }
	
	      this.already_placed_words.push(word_span);
	    }
	  }
	};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dwhome = __webpack_require__(166);
	
	var _dwhome2 = _interopRequireDefault(_dwhome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    dwhome: _dwhome2.default
	  },
	  data: function data() {
	    return {};
	  },
	
	  created: function created() {},
	  computed: {},
	  methods: {}
	};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(181);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _name$components$data;
	
	var _vueTagCloud = __webpack_require__(230);
	
	var _vueTagCloud2 = _interopRequireDefault(_vueTagCloud);
	
	var _lodash = __webpack_require__(223);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _store = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_name$components$data = {
	  name: 'dwhome',
	  components: {},
	  data: function data() {
	    return {
	      selected: 'Popular',
	      loading: false,
	      featured_datasets: [],
	      recent_integrations: [],
	      tag_cloud: [],
	      recent_data_partners: {},
	      datasets_popular: {},
	      datasets_new: {},
	      datasets_rising: {},
	      users_popular: {},
	      users_new: {},
	      users_rising: {},
	      slide: 0,
	      sliding: null,
	      tagData: [{ text: "Lorem", weight: 15, link: "https://google.com" }, { text: "Ipsum", weight: 9 }, { text: "Dolor", weight: 6 }, { text: "Sit", weight: 7 }, { text: "Amet", weight: 5 }]
	    };
	  },
	
	  mounted: function mounted() {
	    this.get();
	  }
	}, (0, _defineProperty3.default)(_name$components$data, 'components', {
	  VueTagCloud: _vueTagCloud2.default
	}), (0, _defineProperty3.default)(_name$components$data, 'computed', {
	  sorted_featured_datasets: function sorted_featured_datasets() {
	    return this.featured_datasets;
	  },
	  filtered_recent_integrations: function filtered_recent_integrations() {
	    if (this.recent_integrations && this.recent_integrations.length) {
	      return this.recent_integrations.slice(0, 10);
	    } else {
	      return [];
	    }
	  },
	  filtered_recent_data_partners: function filtered_recent_data_partners() {
	    if (this.recent_data_partners && this.recent_data_partners.length) {
	      return this.recent_data_partners.slice(0, 5);
	    } else {
	      return [];
	    }
	  },
	  filtered_datasets_popular: function filtered_datasets_popular() {
	    if (this.datasets_popular && this.datasets_popular.length) {
	      return this.datasets_popular.slice(0, 10);
	    } else {
	      return [];
	    }
	  },
	  filtered_datasets_new: function filtered_datasets_new() {
	    if (this.datasets_new && this.datasets_new.length) {
	      return this.datasets_new.slice(0, 7);
	    } else {
	      return [];
	    }
	  },
	  filtered_datasets_rising: function filtered_datasets_rising() {
	    if (this.datasets_rising && this.datasets_rising.length) {
	      return this.datasets_rising.slice(0, 10);
	    } else {
	      return [];
	    }
	  },
	  filtered_users_popular: function filtered_users_popular() {
	    if (this.users_popular && this.users_popular.length) {
	      return this.users_popular.slice(0, 10);
	    } else {
	      return [];
	    }
	  },
	  filtered_users_new: function filtered_users_new() {
	    if (this.users_new && this.users_new.length) {
	      return this.users_new.slice(0, 10);
	    } else {
	      return [];
	    }
	  },
	  filtered_users_rising: function filtered_users_rising() {
	    if (this.users_rising && this.users_rising.length) {
	      return this.users_rising.slice(0, 10);
	    } else {
	      return [];
	    }
	  }
	}), (0, _defineProperty3.default)(_name$components$data, 'methods', {
	  onSlideStart: function onSlideStart(slide) {
	    this.sliding = true;
	  },
	  onSlideEnd: function onSlideEnd(slide) {
	    this.sliding = false;
	  },
	  get: function get() {
	    var _this = this;
	
	    this.loading = true;
	    this.$http.get(_store.FEATURED_DATASETS, { emulateJSON: true }).then(function (response) {
	      _this.featured_datasets = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.RECENT_INTEGRATIONS, { emulateJSON: true }).then(function (response) {
	      _this.recent_integrations = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.TAG_CLOUD, { emulateJSON: true }).then(function (response) {
	      _this.tag_cloud = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.RECENT_DATA_PARTNERS, { emulateJSON: true }).then(function (response) {
	      _this.recent_data_partners = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.DATASETS_POPULAR, { emulateJSON: true }).then(function (response) {
	      _this.datasets_popular = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.DATASETS_NEW, { emulateJSON: true }).then(function (response) {
	      _this.datasets_new = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.DATASETS_RISING, { emulateJSON: true }).then(function (response) {
	      _this.datasets_rising = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.USERS_POPULAR, { emulateJSON: true }).then(function (response) {
	      _this.users_popular = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.USERS_NEW, { emulateJSON: true }).then(function (response) {
	      _this.users_new = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	
	    this.$http.get(_store.USERS_RISING, { emulateJSON: true }).then(function (response) {
	      _this.users_rising = response.body;
	
	      _this.loading = false;
	    }, function (response) {});
	  }
	}), _name$components$data);

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 43,
		"./af.js": 43,
		"./ar": 50,
		"./ar-dz": 44,
		"./ar-dz.js": 44,
		"./ar-kw": 45,
		"./ar-kw.js": 45,
		"./ar-ly": 46,
		"./ar-ly.js": 46,
		"./ar-ma": 47,
		"./ar-ma.js": 47,
		"./ar-sa": 48,
		"./ar-sa.js": 48,
		"./ar-tn": 49,
		"./ar-tn.js": 49,
		"./ar.js": 50,
		"./az": 51,
		"./az.js": 51,
		"./be": 52,
		"./be.js": 52,
		"./bg": 53,
		"./bg.js": 53,
		"./bm": 54,
		"./bm.js": 54,
		"./bn": 55,
		"./bn.js": 55,
		"./bo": 56,
		"./bo.js": 56,
		"./br": 57,
		"./br.js": 57,
		"./bs": 58,
		"./bs.js": 58,
		"./ca": 59,
		"./ca.js": 59,
		"./cs": 60,
		"./cs.js": 60,
		"./cv": 61,
		"./cv.js": 61,
		"./cy": 62,
		"./cy.js": 62,
		"./da": 63,
		"./da.js": 63,
		"./de": 66,
		"./de-at": 64,
		"./de-at.js": 64,
		"./de-ch": 65,
		"./de-ch.js": 65,
		"./de.js": 66,
		"./dv": 67,
		"./dv.js": 67,
		"./el": 68,
		"./el.js": 68,
		"./en-au": 69,
		"./en-au.js": 69,
		"./en-ca": 70,
		"./en-ca.js": 70,
		"./en-gb": 71,
		"./en-gb.js": 71,
		"./en-ie": 72,
		"./en-ie.js": 72,
		"./en-il": 73,
		"./en-il.js": 73,
		"./en-nz": 74,
		"./en-nz.js": 74,
		"./eo": 75,
		"./eo.js": 75,
		"./es": 78,
		"./es-do": 76,
		"./es-do.js": 76,
		"./es-us": 77,
		"./es-us.js": 77,
		"./es.js": 78,
		"./et": 79,
		"./et.js": 79,
		"./eu": 80,
		"./eu.js": 80,
		"./fa": 81,
		"./fa.js": 81,
		"./fi": 82,
		"./fi.js": 82,
		"./fo": 83,
		"./fo.js": 83,
		"./fr": 86,
		"./fr-ca": 84,
		"./fr-ca.js": 84,
		"./fr-ch": 85,
		"./fr-ch.js": 85,
		"./fr.js": 86,
		"./fy": 87,
		"./fy.js": 87,
		"./gd": 88,
		"./gd.js": 88,
		"./gl": 89,
		"./gl.js": 89,
		"./gom-latn": 90,
		"./gom-latn.js": 90,
		"./gu": 91,
		"./gu.js": 91,
		"./he": 92,
		"./he.js": 92,
		"./hi": 93,
		"./hi.js": 93,
		"./hr": 94,
		"./hr.js": 94,
		"./hu": 95,
		"./hu.js": 95,
		"./hy-am": 96,
		"./hy-am.js": 96,
		"./id": 97,
		"./id.js": 97,
		"./is": 98,
		"./is.js": 98,
		"./it": 99,
		"./it.js": 99,
		"./ja": 100,
		"./ja.js": 100,
		"./jv": 101,
		"./jv.js": 101,
		"./ka": 102,
		"./ka.js": 102,
		"./kk": 103,
		"./kk.js": 103,
		"./km": 104,
		"./km.js": 104,
		"./kn": 105,
		"./kn.js": 105,
		"./ko": 106,
		"./ko.js": 106,
		"./ky": 107,
		"./ky.js": 107,
		"./lb": 108,
		"./lb.js": 108,
		"./lo": 109,
		"./lo.js": 109,
		"./lt": 110,
		"./lt.js": 110,
		"./lv": 111,
		"./lv.js": 111,
		"./me": 112,
		"./me.js": 112,
		"./mi": 113,
		"./mi.js": 113,
		"./mk": 114,
		"./mk.js": 114,
		"./ml": 115,
		"./ml.js": 115,
		"./mn": 116,
		"./mn.js": 116,
		"./mr": 117,
		"./mr.js": 117,
		"./ms": 119,
		"./ms-my": 118,
		"./ms-my.js": 118,
		"./ms.js": 119,
		"./mt": 120,
		"./mt.js": 120,
		"./my": 121,
		"./my.js": 121,
		"./nb": 122,
		"./nb.js": 122,
		"./ne": 123,
		"./ne.js": 123,
		"./nl": 125,
		"./nl-be": 124,
		"./nl-be.js": 124,
		"./nl.js": 125,
		"./nn": 126,
		"./nn.js": 126,
		"./pa-in": 127,
		"./pa-in.js": 127,
		"./pl": 128,
		"./pl.js": 128,
		"./pt": 130,
		"./pt-br": 129,
		"./pt-br.js": 129,
		"./pt.js": 130,
		"./ro": 131,
		"./ro.js": 131,
		"./ru": 132,
		"./ru.js": 132,
		"./sd": 133,
		"./sd.js": 133,
		"./se": 134,
		"./se.js": 134,
		"./si": 135,
		"./si.js": 135,
		"./sk": 136,
		"./sk.js": 136,
		"./sl": 137,
		"./sl.js": 137,
		"./sq": 138,
		"./sq.js": 138,
		"./sr": 140,
		"./sr-cyrl": 139,
		"./sr-cyrl.js": 139,
		"./sr.js": 140,
		"./ss": 141,
		"./ss.js": 141,
		"./sv": 142,
		"./sv.js": 142,
		"./sw": 143,
		"./sw.js": 143,
		"./ta": 144,
		"./ta.js": 144,
		"./te": 145,
		"./te.js": 145,
		"./tet": 146,
		"./tet.js": 146,
		"./tg": 147,
		"./tg.js": 147,
		"./th": 148,
		"./th.js": 148,
		"./tl-ph": 149,
		"./tl-ph.js": 149,
		"./tlh": 150,
		"./tlh.js": 150,
		"./tr": 151,
		"./tr.js": 151,
		"./tzl": 152,
		"./tzl.js": 152,
		"./tzm": 154,
		"./tzm-latn": 153,
		"./tzm-latn.js": 153,
		"./tzm.js": 154,
		"./ug-cn": 155,
		"./ug-cn.js": 155,
		"./uk": 156,
		"./uk.js": 156,
		"./ur": 157,
		"./ur.js": 157,
		"./uz": 159,
		"./uz-latn": 158,
		"./uz-latn.js": 158,
		"./uz.js": 159,
		"./vi": 160,
		"./vi.js": 160,
		"./x-pseudo": 161,
		"./x-pseudo.js": 161,
		"./yo": 162,
		"./yo.js": 162,
		"./zh-cn": 163,
		"./zh-cn.js": 163,
		"./zh-hk": 164,
		"./zh-hk.js": 164,
		"./zh-tw": 165,
		"./zh-tw.js": 165
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 224;


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(220)
	
	var Component = __webpack_require__(29)(
	  /* script */
	  __webpack_require__(174),
	  /* template */
	  __webpack_require__(232),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(221)
	
	var Component = __webpack_require__(29)(
	  /* script */
	  __webpack_require__(173),
	  /* template */
	  __webpack_require__(233),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12 portfolio-item"
	  }, [_c('div', {
	    staticClass: "card h-100"
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_c('icon', {
	    attrs: {
	      "name": "star",
	      "scale": "1.5"
	    }
	  }), _vm._v(" Featured Datasets "), _c('a', {
	    staticClass: "view-all",
	    attrs: {
	      "target": "_blank",
	      "href": "https://data.world"
	    }
	  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _c('carousel', {
	    attrs: {
	      "perPage": 4,
	      "navigationEnabled": true,
	      "paginationEnabled": false,
	      "perPageCustom": [
	        [0, 2],
	        [800, 4]
	      ],
	      "navigationClickTargetSize": 0,
	      "navigationPrevLabel": '\uf0a8',
	      "navigationNextLabel": '\uf0a9'
	    }
	  }, _vm._l((_vm.sorted_featured_datasets), function(fds, index) {
	    return _c('slide', {}, [_c('div', {
	      staticClass: "card-body"
	    }, [_c('h4', {
	      staticClass: "card-title"
	    }, [_c('a', {
	      attrs: {
	        "href": fds.dataset_url,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fds.week))])]), _vm._v(" "), _c('p', {
	      staticClass: "card-text"
	    }, [_vm._v(_vm._s(fds.topic))])])])
	  }))], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-md-4 col-sm-6 portfolio-item"
	  }, [_c('div', {
	    staticClass: "card h-100"
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_c('icon', {
	    attrs: {
	      "name": "clock",
	      "scale": "1.5"
	    }
	  }), _vm._v(" Recent Integrations"), _c('br'), _c('a', {
	    staticClass: "view-all",
	    attrs: {
	      "target": "_blank",
	      "href": "https://data.world"
	    }
	  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _vm._l((_vm.filtered_recent_integrations), function(fri, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": fri.URL,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fri.name))])])
	  })], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-9 col-md-8 col-sm-12 portfolio-item hidden-md-down"
	  }, [_c('div', {
	    staticClass: "card h-100"
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_c('icon', {
	    attrs: {
	      "name": "tag",
	      "scale": "1.5"
	    }
	  }), _vm._v(" Tag Cloud "), _c('a', {
	    staticClass: "view-all",
	    attrs: {
	      "target": "_blank",
	      "href": "https://data.world"
	    }
	  }, [_vm._v("[view all]")])], 1), _vm._v(" "), (_vm.tag_cloud.length > 10) ? _c('VueTagCloud', {
	    attrs: {
	      "data": _vm.tag_cloud
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-3 col-md-4 col-sm-6 portfolio-item"
	  }, [_c('div', {
	    staticClass: "card h-100"
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_c('icon', {
	    attrs: {
	      "name": "handshake",
	      "scale": "1.5"
	    }
	  }), _vm._v(" Recent Data Partners "), _c('a', {
	    staticClass: "view-all",
	    attrs: {
	      "target": "_blank",
	      "href": "https://data.world"
	    }
	  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _vm._l((_vm.filtered_recent_data_partners), function(frdp, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": frdp.URL,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(frdp.name))]), _vm._v(" "), _c('br'), _vm._v("(" + _vm._s(frdp.dataset_count || 0) + " datasets)")])
	  })], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-9 col-md-8 col-sm-9 portfolio-item"
	  }, [_c('div', {
	    staticClass: "card h-100"
	  }, [_c('div', {
	    staticClass: "card-body"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected),
	      expression: "selected"
	    }],
	    staticClass: "select",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', [_vm._v("Popular")]), _vm._v(" "), _c('option', [_vm._v("New")]), _vm._v(" "), _c('option', [_vm._v("Rising")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-6 col-md-5 col-sm-5 bordered"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_c('icon', {
	    attrs: {
	      "name": "table",
	      "scale": "1.5"
	    }
	  }), _vm._v(" Datasets "), _c('a', {
	    staticClass: "view-all",
	    attrs: {
	      "target": "_blank",
	      "href": "https://data.world"
	    }
	  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.selected === 'Popular') ? _c('div', _vm._l((_vm.filtered_datasets_popular), function(fdp, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": 'https://data.world/' + fdp.owner + '/' + fdp.datasetid,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fdp.owner))]), _vm._v(" (" + _vm._s(fdp.views) + " views)")])
	  })) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.selected === 'New') ? _c('div', _vm._l((_vm.filtered_datasets_new), function(fdn, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": fdn.URL,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fdn.name))])])
	  })) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.selected === 'Rising') ? _c('div', _vm._l((_vm.filtered_datasets_rising), function(fdr, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": 'https://data.world/' + fdr.owner + '/' + fdr.datasetid,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fdr.owner))]), _vm._v(" (" + _vm._s(fdr.views) + " views)")])
	  })) : _vm._e()])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6 col-md-5 col-sm-3"
	  }, [_c('h4', {
	    staticClass: "card-title"
	  }, [_c('icon', {
	    attrs: {
	      "name": "user",
	      "scale": "1.5"
	    }
	  }), _vm._v(" Users "), _c('a', {
	    staticClass: "view-all",
	    attrs: {
	      "target": "_blank",
	      "href": "https://data.world"
	    }
	  }, [_vm._v("[view all]")])], 1), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.selected === 'Popular') ? _c('div', _vm._l((_vm.filtered_users_popular), function(fup, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": 'https://data.world/' + fup.following,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fup.following))]), _vm._v(" (" + _vm._s(fup.count) + " following)")])
	  })) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.selected === 'New') ? _c('div', _vm._l((_vm.filtered_users_new), function(fun, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": 'https://data.world/' + fun.agentid,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fun.displayname))])])
	  })) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.selected === 'Rising') ? _c('div', _vm._l((_vm.filtered_users_rising), function(fur, index) {
	    return _c('p', {
	      staticClass: "card-text"
	    }, [_c('a', {
	      attrs: {
	        "href": 'https://data.world/' + fur.following,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(fur.following))]), _vm._v(" (" + _vm._s(fur.count) + " following)")])
	  })) : _vm._e()])], 1)])])])])]), _vm._v(" "), _c('p', {
	    staticClass: "version"
	  }, [_vm._v("Version 0.0.29, 101618|20.51.10")])])
	},staticRenderFns: []}

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "vue-tag-cloud",
	    attrs: {
	      "id": "vue-tag-cloud"
	    }
	  })])
	}]}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.77ac62690132788717b1.js